export class ImagesBase64 {
    public static readonly player = require('@/assets/games/river-run/themes/speed-race/sprites/car.png');
    public static readonly line = require('@/assets/games/maze-game/line.png');
    static readonly heart = require('@/assets/games/space-rescue/ui/life.png');
    public static readonly road = require('@/assets/games/river-run/themes/speed-race/sprites/road.png');
    public static readonly BgBack = require('@/assets/games/river-run/themes/speed-race/sprites/grass.png');
  }
  